import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
} from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import authService from "services/authService";
import { ForgotPasswordForm } from "components/Forms";
import { ForgotPasswordInstructionsCard } from "components/Card";
import { LoadingModal } from "components/ModalComponent";
import TAGlogo from "assets/images/TAGlogo.svg";

const Alert = React.forwardRef(function Alert(props, ref) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [showCard, setShowCard] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [loading, setLoadingBar] = useState(false);

  const resendEmail = () => {
    setLoadingBar(true);
    setOpenAlert(false);
    authService.resetUserPassword(email.value).then((result) => {
      if (result.status) {
        setOpenAlert(true);
      }
      setLoadingBar(false);
    });
  };
  const responseHandler = (response) => {
    if (response.status) {
      setEmail(response.email);
      setOpenAlert(true);
      setShowCard(true);
    } else {
      setOpenAlert(response);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };
  return (
    <div className="b-forgot-container">
      <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          className="b-forgot-container__alert"
        >
          Reset password link has been sent to your email
        </Alert>
      </Snackbar>
      <Box className="b-forgot-container__box" sx={{ typography: "body1" }}>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <img
              className="b-forgot-container__logo"
              src={TAGlogo}
              alt="Error in loading"
            />
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <div className="b-forgot-container__container">
        <Grid
          container
          spacing={2}
          direction="column"
          alignItems="center"
          justify="center"
          className="form-alignment"
        >
          <Grid className="b-forgot-container__card" item xs={12}>
            <Grid item xs={12}>
              {showCard === false ? (
                <Card className="b-forgot-container__cardHead">
                  <CardContent className="b-forgot-container__content">
                    <Typography className="b-forgot-container__cardheader">
                      <div className="default-card-header-padding">
                        <h2 className="default-card-header-text">
                          Forgot your password?
                        </h2>
                      </div>
                    </Typography>
                  </CardContent>
                  <CardContent className=" b-forgot-container__card-content">
                    <div className="default-card-body-padding">
                      <span className=" b-forgot-container__card-text">
                        Enter the email associated with your account and we’ll
                        send an email with instructions to reset your password.
                      </span>
                    </div>

                    <div
                      className="default-card-body-padding"
                      id="underlinehide"
                    >
                      <ForgotPasswordForm
                        responseFunc={responseHandler}
                        loadingStatusFunc={setLoadingBar}
                      />
                    </div>
                    {/* </div> */}
                  </CardContent>
                </Card>
              ) : (
                <ForgotPasswordInstructionsCard
                  email={email}
                  resendFunc={resendEmail}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </div>
      <div>
        <LoadingModal openLoadingModal={loading} body="Loading" />
      </div>
    </div>
  );
}

export default ForgotPassword;
